<template>
  <div>
    <van-row>
      <van-col :span="8" 
        ><div class="txt-show">{{ $t("recharge.bankname") }}</div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
    <van-row>
      <van-col :span="8"
        ><div class="txt-show">{{ $t("recharge.bankno") }}</div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
    <van-row>
      <van-col :span="8"
        ><div class="txt-show">{{ $t("recharge.accountname") }}</div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
    <van-row>
      <van-col :span="8"
        ><div class="txt-show">{{ $t("recharge.bankaddress") }}</div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
    <van-row>
      <van-col :span="8"
        ><div class="txt-show">{{ $t("recharge.bankcode") }}</div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
    <van-row>
      <van-col :span="8"
        ><div class="txt-show">
          {{ $t("recharge.companyaddress") }}
        </div></van-col
      >
      <van-col :span="12"
        ><div class="txt-show">{{ $t("common.forserver") }}</div></van-col
      >
      <van-col :span="4"
        ><van-button class="web-btn-1" size="small">{{
          $t("common.copy")
        }}</van-button></van-col
      >
    </van-row>
  </div>
</template>

<script>
export default {
  name: "BankRecharge",
  props:['bank'],
  computed:{
    safeBank(){
        return this.bank || {}
    }
  }
};
</script>

<style>
</style>
